export default __webpack_public_path__ + "static/media/rotate-counter-clockwise-icon.9edbd72c.svg";